import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  Alert,
  Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { ToastContainer, toast } from "react-toastify";
import { saveRecords } from "../../services/api.service";
import logodark from "../../assets/images/logo-dark.png";

const ForgetPasswordPage = (props) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [password, setPassword] = useState("")
  const [passwordVisible, setPasswordVisible] = useState(false)

  const [confirmPassword, setConfirmPassword] = useState("")
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false)

  const handleValidSubmit = async (event, values) => {
    setLoading(true);

    setOtpSent(true);
    try {
      // CASE 1 → OTP NOT SENT → SEND OTP
      if (!otpSent) {
        const response = await saveRecords(values, "/auth/forgot-password");

        if (true) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
        return; // STOP HERE
      }

      // CASE 2 → OTP SENT → RESET PASSWORD
      const payload = {
        email: values.email,
        otp: values.otp,
        newPassword: values.password,
        confirmPassword: values.confirm_password,
      };

      const response = await saveRecords(payload, "/auth/reset-password");

      if (response.status) {
        toast.success(response.message);
        navigate("/login");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner size="sm" color="primary" />
        </div>
      )}

      <Container fluid className="p-0">
        <Row className="g-0">
          <Col lg={4}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div className="text-center">
                      <Link to="/" className="logo">
                        <img src={logodark} height="40" alt="logo" />
                      </Link>
                      <h4 className="font-size-18 mt-4">Reset Password</h4>
                    </div>

                    <div className="p-2 mt-5">
                      {props.forgetError && (
                        <Alert color="danger" className="mb-4">
                          {props.forgetError}
                        </Alert>
                      )}

                      {props.message && (
                        <Alert color="success" className="mb-4">
                          {props.message}
                        </Alert>
                      )}

                      <AvForm onValidSubmit={handleValidSubmit}>
                        {/* EMAIL */}
                        <div className="auth-form-group-custom mb-4">
                          <i className="ri-mail-line auti-custom-input-icon"></i>
                          <Label>Email</Label>
                          <AvField
                            name="email"
                            type="email"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Email is required",
                              },
                              pattern: {
                                value:
                                  "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                                errorMessage: "Enter valid email",
                              },
                            }}
                            className="form-control"
                            placeholder="Enter email"
                            onChange={() => setOtpSent(false)}
                          />
                        </div>

                        {/* EXTRA FIELDS AFTER OTP */}
                        {otpSent && (
                          <>
                            <div className="auth-form-group-custom mb-4">
                              <Label>OTP</Label>
                              <AvField
                                name="otp"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "OTP required",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter OTP"
                              />
                            </div>

                            <div className="auth-form-group-custom mb-4">
                              <Label>New Password</Label>
                              <AvField
                                name="password"
                                value={password}
                                onChange={(e)=>setPassword(e.target.value)}
                                type={passwordVisible ? "text" : "password"}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Password required",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage: "Min 6 characters",
                                  },
                                }}
                                className="form-control"
                                placeholder="New password"
                              />
                              {password?.length !== 0 && (<button
                                type="button"
                                onClick={() => setPasswordVisible(!passwordVisible)}
                                style={{
                                  position: "absolute",
                                  top: "54%",
                                  right: "10px",
                                  transform: "translateY(-50%)",
                                  background: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                {passwordVisible ? (
                                  <i
                                    className="ri-eye-line"
                                    style={{ fontSize: "1.2em" }}
                                  ></i>
                                ) : (
                                  <i
                                    className="ri-eye-off-line"
                                    style={{ fontSize: "1.2em" }}
                                  ></i>
                                )}
                              </button>)}
                            </div>

                            <div className="auth-form-group-custom mb-4">
                              <Label>Confirm Password</Label>
                              <AvField
                                name="confirm_password"
                                type={confirmPasswordVisible ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e)=>setConfirmPassword(e.target.value)}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Confirm password",
                                  },
                                  match: {
                                    value: "password",
                                    errorMessage: "Passwords do not match",
                                  },
                                }}
                                className="form-control"
                                placeholder="Confirm password"
                              />
                              {confirmPassword?.length !== 0 && (<button
                                type="button"
                                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                style={{
                                  position: "absolute",
                                  top: "54%",
                                  right: "10px",
                                  transform: "translateY(-50%)",
                                  background: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                {confirmPasswordVisible ? (
                                  <i
                                    className="ri-eye-line"
                                    style={{ fontSize: "1.2em" }}
                                  ></i>
                                ) : (
                                  <i
                                    className="ri-eye-off-line"
                                    style={{ fontSize: "1.2em" }}
                                  ></i>
                                )}
                              </button>)}
                            </div>
                          </>
                        )}

                        <div className="mt-4 text-center">
                          <Button
                            color="primary"
                            className="w-md"
                            type="submit"
                            style={{ background: "#006eb9" }}
                          >
                            {loading
                              ? "Loading..."
                              : otpSent
                                ? "Reset Password"
                                : "Send OTP"}
                          </Button>
                        </div>
                      </AvForm>
                    </div>

                    <div className="mt-4 text-center">
                      <p>
                        Don't have an account?{" "}
                        <Link to="/register" className="fw-medium text-primary">
                          Register
                        </Link>
                      </p>
                    </div>

                    <div className="mt-0 text-center">
                      <p>
                        Already have an account?{" "}
                        <Link to="/login" className="fw-medium text-primary">
                          Login
                        </Link>
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col lg={8}>
            <div className="authentication-bg"></div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ForgetPasswordPage;
